import { useSearchParams, useNavigate, useLocation, useRouteLoaderData } from 'react-router';
import { idPublicTournamentIndex } from '../layout';
import type { GroupPhaseWindow, PublicTournament } from '@repo/shared-types';

const ALL_STEPS = [
  'nombre',
  'telefono',
  'companero',
  'categoria',
  'horarios',
  'confirmacion',
] as const;

const STEPS_WITHOUT_SCHEDULE = [
  'nombre',
  'telefono',
  'companero',
  'categoria',
  'confirmacion',
] as const;

export function useWizardNavigation() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { tournament } = useRouteLoaderData(idPublicTournamentIndex) as {
    tournament: PublicTournament;
  };

  const groupPhaseWindows: GroupPhaseWindow[] = tournament.groupPhaseWindows ?? [];
  const hasScheduleStep = groupPhaseWindows.length > 0;
  const minRequiredInterests: number = tournament.minRequiredInterests ?? 1;

  const steps: readonly string[] = hasScheduleStep ? ALL_STEPS : STEPS_WITHOUT_SCHEDULE;

  const currentPath = location.pathname.split('/').pop() || '';
  const currentIndex = steps.indexOf(currentPath);
  const totalSteps = steps.length;

  const navigateToStep = (stepPath: string, extraParams?: Record<string, string>) => {
    const params = new URLSearchParams(searchParams);
    if (extraParams) {
      for (const [key, value] of Object.entries(extraParams)) {
        if (value !== undefined && value !== null && value !== '') {
          params.set(key, value);
        } else {
          params.delete(key);
        }
      }
    }
    navigate({ pathname: `../${stepPath}`, search: params.toString() }, { replace: false });
  };

  const goNext = (extraParams?: Record<string, string>) => {
    if (currentIndex < steps.length - 1) {
      navigateToStep(steps[currentIndex + 1], extraParams);
    }
  };

  const goBack = () => {
    if (currentIndex > 0) {
      navigateToStep(steps[currentIndex - 1]);
    }
  };

  return {
    searchParams,
    goNext,
    goBack,
    navigateToStep,
    currentIndex,
    totalSteps,
    steps,
    canGoBack: currentIndex > 0,
    tournament,
    groupPhaseWindows,
    hasScheduleStep,
    minRequiredInterests,
  };
}
